module.exports = __webpack_public_path__ + "img/ad4_img.14ced6d4.png";